<div class="flex gap-3">
  @for (
    action of actions | onlyVisibleTableCollectionActions: selection;
    track action
  ) {
    <div>
      <app-table-collection-action
        [action]="action"
        [selection]="selection" />
    </div>
  }
</div>
